import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  output,
  type InputSignal,
  type OutputEmitterRef,
  type Signal,
} from '@angular/core';
import type { UiChoiceGroupLayout } from '../../types/ui-choice-group-layout.type';
import type { UiChoiceOption } from '../../types/ui-choice-option.interface';

@Component({
  selector: 'ui-choice-group',
  imports: [],
  templateUrl: './ui-choice-group.component.html',
  styleUrl: './ui-choice-group.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UiChoiceGroupComponent {
  public readonly options: InputSignal<readonly UiChoiceOption[]> = input.required<readonly UiChoiceOption[]>();
  public readonly selectedOptionId: InputSignal<string | null> = input<string | null>(null);
  public readonly ariaLabel: InputSignal<string> = input.required<string>();
  public readonly describedBy: InputSignal<string | null> = input<string | null>(null);
  public readonly invalid: InputSignal<boolean> = input<boolean>(false);
  public readonly required: InputSignal<boolean> = input<boolean>(false);
  public readonly layout: InputSignal<UiChoiceGroupLayout> = input<UiChoiceGroupLayout>('auto');
  public readonly selectedOptionIdChange: OutputEmitterRef<string> = output<string>();

  protected readonly isAuto: Signal<boolean> = computed((): boolean => this.layout() === 'auto');
  protected readonly isStack: Signal<boolean> = computed((): boolean => this.layout() === 'stack');
  protected readonly isTwoColumn: Signal<boolean> = computed((): boolean => this.layout() === 'two');
  protected readonly isThreeColumn: Signal<boolean> = computed((): boolean => this.layout() === 'three');

  protected handleOptionSelected(option: UiChoiceOption): void {
    if (option.disabled === true) {
      return;
    }

    this.selectedOptionIdChange.emit(option.id);
  }
}
